//import dependencies (styles, script,etc)
import '../styles/output.css'
//return the about me section
let About=()=>{
    return(
        <div className='main flex flex-col bg-neutral-950 px-2 py-3 mobile-l:flex-row-reverse mobile-l:py-8'>
            {/* Text container */}
            <div className='mobile-l:w-1/2 px-2'>
              <div>
                <h3 className='text-xl text-white font-bold px-2 py-1 underline decoration-yellow-400'>About</h3>
              </div>

              <div>
                <p className='py-2 px-2 text-white'>
                Hello there , I'm Roy Miya and i make art or as the corporate world would say, I'm a graphic designer mainly specialised in cover arts , YouTube thumbnails, Album covers & event posters . Notable entities and artists ive worked with include Trap Halisi, Skye The Presence, Kloutted Freshmen Mag, Nairobi City Thunder, smokingskul . I'm 22 years old based in Nairobi, Kenya
                </p>
              </div>

            </div>
             {/* Image container */}
             <div className='mobile-l:w-1/2'>
                <div className='flex flex-row justify-center items-center mobile-l:items-start'>
                    <img src='/images/subject/1001351921.jpg' loading='lazy' alt='' className='w-52 h-72 before:w-52 before:h-72 before:absolute before:right-16 before:bottom-24 before:bg-neutral-950'/>
                </div>
            </div>
        </div>
    )
}
export default About;
